// Mock data for Order Management System

export const mockOrders = [
  {
    id: 1,
    orderNumber: 'ORD-001',
    orderDate: '2024-01-20',
    brandName: 'AgriGold Premium',
    brandId: 'BID-001',
    quantity: 10000,
    price: 150,
    poNumber: 'PO-2024-001',
    deliveryAddress: '123 Warehouse Street, Mumbai',
    billingAddress: '456 Office Complex, Mumbai',
    status: 'Pending',
    balance: 7000,
    dispatches: [
      {
        id: 1,
        dispatchDate: '2024-01-25',
        dispatchNumber: 'DISP-001',
        quantity: 3000,
        weightInKgs: 540.0
      }
    ],
    orderNotes: []
  },
  {
    id: 2,
    orderNumber: 'ORD-002',
    orderDate: '2024-01-22',
    brandName: 'FreshHarvest',
    brandId: 'BID-002',
    quantity: 5000,
    price: 120,
    poNumber: 'PO-2024-002',
    deliveryAddress: '789 Distribution Center, Delhi',
    billingAddress: '321 Corporate Plaza, Delhi',
    status: 'Pending',
    balance: 5000,
    dispatches: [],
    orderNotes: []
  },
  {
    id: 3,
    orderNumber: 'ORD-003',
    orderDate: '2024-01-18',
    brandName: 'AgriGold Premium',
    brandId: 'BID-001',
    quantity: 8000,
    price: 150,
    poNumber: 'PO-2024-003',
    deliveryAddress: '555 Storage Facility, Pune',
    billingAddress: '123 Warehouse Street, Mumbai',
    status: 'Complete',
    balance: 0,
    dispatches: [
      {
        id: 2,
        dispatchDate: '2024-01-20',
        dispatchNumber: 'DISP-002',
        quantity: 8000,
        weightInKgs: 1440.0
      }
    ],
    orderNotes: []
  }
];

export const mockUsers = [
  {
    id: 1,
    username: 'admin',
    email: 'admin@company.com',
    role: 'Admin',
    name: 'System Administrator',
    status: 'Active',
    createdAt: '2024-01-01T00:00:00.000Z',
    modifiedAt: '2024-01-01T00:00:00.000Z',
    createdBy: 'System',
    permissions: {
      orders: { view: true, add: true, edit: true, delete: true, export: true },
      brandSpecs: { view: true, add: true, edit: true, delete: true, download: true },
      dispatches: { view: true, add: true, edit: true, delete: true },
      reports: { view: true, generate: true }
    }
  },
  {
    id: 2,
    username: 'manager',
    email: 'manager@company.com',
    role: 'Manager',
    name: 'Production Manager',
    status: 'Active',
    createdAt: '2024-01-01T00:00:00.000Z',
    modifiedAt: '2024-01-01T00:00:00.000Z',
    createdBy: 'System',
    permissions: {
      orders: { view: true, add: true, edit: true, delete: false, export: true },
      brandSpecs: { view: true, add: true, edit: true, delete: false, download: true },
      dispatches: { view: true, add: true, edit: true, delete: false },
      reports: { view: true, generate: true }
    }
  },
  {
    id: 3,
    username: 'operator',
    email: 'operator@company.com',
    role: 'Operator',
    name: 'Dispatch Operator',
    status: 'Active',
    createdAt: '2024-01-01T00:00:00.000Z',
    modifiedAt: '2024-01-01T00:00:00.000Z',
    createdBy: 'System',
    permissions: {
      orders: { view: true, add: true, edit: false, delete: false, export: false },
      brandSpecs: { view: true, add: false, edit: false, delete: false, download: false },
      dispatches: { view: true, add: true, edit: false, delete: false },
      reports: { view: false, generate: false }
    }
  }
];

// Utility functions for mock data management
export const orderManager = {
  orders: [...mockOrders],
  nextId: 4,
  nextOrderNumber: 4,
  
  getAllOrders() {
    return this.orders;
  },
  
  getOrderById(id) {
    return this.orders.find(order => order.id === parseInt(id));
  },
  
  addOrder(orderData) {
    const newOrder = {
      id: this.nextId++,
      orderNumber: `ORD-${String(this.nextOrderNumber++).padStart(3, '0')}`,
      ...orderData,
      dispatches: [],
      balance: orderData.quantity,
      status: 'Pending'
    };
    this.orders.unshift(newOrder);
    this.saveToStorage();
    
    // If the order has notes, trigger notifications
    if (orderData.orderNotes && orderData.orderNotes.length > 0 && typeof orderNotificationsManager !== 'undefined') {
      orderData.orderNotes.forEach(note => {
        orderNotificationsManager.addOrderNoteNotification(
          newOrder.id,
          newOrder.brandName,
          orderData.orderNotes.length,
          note.userName,
          note.text
        );
      });
    }
    
    return newOrder;
  },
  
  updateOrder(id, orderData) {
    const index = this.orders.findIndex(order => order.id === parseInt(id));
    if (index !== -1) {
      // Check if notes were updated and trigger notifications
      const oldNotesCount = (this.orders[index].orderNotes || []).length;
      const newNotesCount = (orderData.orderNotes || []).length;
      
      this.orders[index] = { ...this.orders[index], ...orderData };
      this.calculateBalance(this.orders[index]);
      this.saveToStorage();
      
      // If a new note was added, trigger notification
      if (newNotesCount > oldNotesCount && orderData.orderNotes) {
        const latestNote = orderData.orderNotes[orderData.orderNotes.length - 1];
        if (latestNote && typeof orderNotificationsManager !== 'undefined') {
          orderNotificationsManager.addOrderNoteNotification(
            this.orders[index].id,
            this.orders[index].brandName,
            newNotesCount,
            latestNote.userName,
            latestNote.text
          );
        }
      }
      
      return this.orders[index];
    }
    return null;
  },

  addOrderNote(orderId, noteData) {
    const order = this.getOrderById(orderId);
    if (order) {
      if (!order.orderNotes) {
        order.orderNotes = [];
      }
      
      const newNote = {
        id: Date.now() + Math.random(),
        ...noteData,
        timestamp: new Date().toISOString(),
        createdAt: new Date().toLocaleString('en-IN')
      };
      
      order.orderNotes.push(newNote);
      this.saveToStorage();
      
      // Trigger notification for all users
      if (typeof orderNotificationsManager !== 'undefined') {
        orderNotificationsManager.addOrderNoteNotification(
          order.id,
          order.brandName,
          order.orderNotes.length,
          newNote.userName,
          newNote.text
        );
      }
      
      return { success: true, order, note: newNote };
    }
    return { success: false, message: 'Order not found' };
  },
  
  addDispatch(orderId, dispatchData) {
    const order = this.getOrderById(orderId);
    if (order) {
      const newDispatch = {
        id: Date.now(),
        ...dispatchData
      };
      order.dispatches.push(newDispatch);
      this.calculateBalance(order);
      this.saveToStorage();
      return { success: true, order };
    }
    return { success: false, message: 'Order not found' };
  },

  updateDispatch(orderId, dispatchId, updatedDispatchData) {
    const order = this.getOrderById(orderId);
    if (order) {
      const dispatchIndex = order.dispatches.findIndex(d => d.id === dispatchId);
      if (dispatchIndex !== -1) {
        order.dispatches[dispatchIndex] = { ...order.dispatches[dispatchIndex], ...updatedDispatchData };
        this.calculateBalance(order);
        this.saveToStorage();
        return { success: true, order };
      }
      return { success: false, message: 'Dispatch not found' };
    }
    return { success: false, message: 'Order not found' };
  },

  deleteDispatch(orderId, dispatchId) {
    const order = this.getOrderById(orderId);
    if (order) {
      const dispatchIndex = order.dispatches.findIndex(d => d.id === dispatchId);
      if (dispatchIndex !== -1) {
        order.dispatches.splice(dispatchIndex, 1);
        this.calculateBalance(order);
        this.saveToStorage();
        return { success: true, order };
      }
      return { success: false, message: 'Dispatch not found' };
    }
    return { success: false, message: 'Order not found' };
  },
  
  calculateBalance(order) {
    const totalDispatched = order.dispatches.reduce((sum, dispatch) => sum + dispatch.quantity, 0);
    order.balance = order.quantity - totalDispatched;
    order.status = order.balance === 0 ? 'Complete' : 'Pending';
  },
  
  deleteOrder(id) {
    const index = this.orders.findIndex(order => order.id === parseInt(id));
    if (index !== -1) {
      this.orders.splice(index, 1);
      this.saveToStorage();
      return true;
    }
    return false;
  },
  
  searchOrders(query) {
    const searchTerm = query.toLowerCase();
    return this.orders.filter(order => 
      order.brandName.toLowerCase().includes(searchTerm) ||
      order.poNumber.toLowerCase().includes(searchTerm) ||
      order.materialType.toLowerCase().includes(searchTerm) ||
      order.status.toLowerCase().includes(searchTerm)
    );
  },
  
  filterOrdersByStatus(status) {
    if (status === 'All') return this.orders;
    return this.orders.filter(order => order.status === status);
  },
  
  getOrdersByDateRange(startDate, endDate) {
    return this.orders.filter(order => {
      const orderDate = new Date(order.orderDate);
      return orderDate >= new Date(startDate) && orderDate <= new Date(endDate);
    });
  },
  
  saveToStorage() {
    localStorage.setItem('orders', JSON.stringify(this.orders));
  },
  
  // Clear all data for testing
  clearAllData() {
    localStorage.removeItem('orders');
    localStorage.removeItem('brandSpecs');
    localStorage.removeItem('users');
    localStorage.removeItem('notifications');
    console.log('All localStorage data cleared for fresh testing');
    // Reinitialize with empty data
    this.orders = [];
    this.nextId = 1;
    this.nextOrderNumber = 1;
    this.saveToStorage();
  },

  loadFromStorage() {
    const saved = localStorage.getItem('orders');
    if (saved) {
      const parsedOrders = JSON.parse(saved);
      // Check if saved orders have orderNumber and proper brandId format
      const hasOrderNumbers = parsedOrders.some(o => o.orderNumber);
      const hasBrandIds = parsedOrders.some(o => typeof o.brandId === 'string' && o.brandId.startsWith('BID-'));
      
      if (hasOrderNumbers && hasBrandIds) {
        // Use saved data if it has both orderNumber and brandId fields
        this.orders = parsedOrders;
        this.nextId = Math.max(...this.orders.map(o => o.id), 0) + 1;
        // Initialize nextOrderNumber based on existing order numbers
        const existingOrderNumbers = this.orders
          .map(o => o.orderNumber)
          .filter(on => on && on.startsWith('ORD-'))
          .map(on => parseInt(on.replace('ORD-', '')))
          .filter(num => !isNaN(num));
        this.nextOrderNumber = existingOrderNumbers.length > 0 ? Math.max(...existingOrderNumbers) + 1 : 1;
      } else {
        // Clear corrupted data and reinitialize with mockOrders
        localStorage.removeItem('orders');
        this.orders = [...mockOrders];
        this.nextId = 4;
        this.nextOrderNumber = 4;
        this.saveToStorage();
      }
    } else {
      // Initialize with mockOrders if no saved data
      this.orders = [...mockOrders];
      this.nextId = 4;
      this.nextOrderNumber = 4;
      this.saveToStorage();
    }
  },

  // Helper method to fix orders with missing brandIds
  fixOrderBrandIds() {
    let needsSaving = false;
    this.orders.forEach(order => {
      if (order.brandName && !order.brandId) {
        // Try to find matching brandId based on brandName
        const matchingBrand = brandSpecsManager.brands.find(brand => brand.brandName === order.brandName);
        if (matchingBrand) {
          order.brandId = matchingBrand.brandId;
          needsSaving = true;
          console.log(`Fixed brandId for order ${order.id}: ${order.brandName} -> ${order.brandId}`);
        }
      }
    });
    if (needsSaving) {
      this.saveToStorage();
    }
  },
  
  getStats() {
    const totalOrders = this.orders.length;
    const pendingOrders = this.orders.filter(o => o.status === 'Pending').length;
    const completeOrders = this.orders.filter(o => o.status === 'Complete').length;
    const totalValue = this.orders.reduce((sum, order) => sum + order.price, 0);
    const pendingValue = this.orders
      .filter(o => o.status === 'Pending')
      .reduce((sum, order) => sum + (order.price * (order.balance / order.quantity)), 0);
    
    return {
      totalOrders,
      pendingOrders,
      completeOrders,
      totalValue,
      pendingValue
    };
  },

  downloadOrdersAsExcel() {
    const orders = this.getAllOrders();
    
    // Create CSV data (simpler than actual Excel, but compatible)
    const csvHeaders = [
      'Order ID',
      'Order Date', 
      'Brand Name',
      'PO Number',
      'Bill To',
      'Ship To',
      'Quantity',
      'Unit',
      'Price (₹)',
      'Balance Quantity',
      'Status',
      'Total Dispatches',
      'Notes Count'
    ];
    
    const csvRows = orders.map(order => [
      order.id,
      order.orderDate,
      order.brandName,
      order.poNumber || 'N/A',
      order.billTo || 'N/A',
      order.shipTo || 'N/A',
      order.quantity,
      order.unit,
      `₹${new Intl.NumberFormat('en-IN').format(order.price)}`,
      order.balance,
      order.status,
      order.dispatches.length,
      (order.orderNotes || []).length
    ]);
    
    // Convert to CSV format
    const csvContent = [
      csvHeaders.join(','),
      ...csvRows.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');
    
    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `orders-export-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return { success: true, message: 'Orders exported to Excel successfully' };
  },

  downloadAllOrdersJSON() {
    const orders = this.getAllOrders();
    const dataStr = JSON.stringify(orders, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `orders-data-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return { success: true, message: 'All orders data downloaded successfully' };
  },

  importOrders(ordersData) {
    try {
      if (Array.isArray(ordersData)) {
        this.orders = [...ordersData];
        if (this.orders.length > 0) {
          this.nextId = Math.max(...this.orders.map(o => o.id), 0) + 1;
        }
        this.saveToStorage();
        return { success: true, message: `${ordersData.length} orders imported successfully` };
      } else {
        return { success: false, message: 'Invalid data format' };
      }
    } catch (error) {
      return { success: false, message: 'Failed to import data: ' + error.message };
    }
  }
};

// Initialize from storage
orderManager.loadFromStorage();

// Auth manager
export const authManager = {
  currentUser: null,
  users: [...mockUsers],
  nextUserId: 4,
  
  login(username, password) {
    // Mock authentication - in real app, this would be API call
    const user = this.users.find(u => u.username === username && u.status === 'Active');
    if (user && password === 'password') { // Mock password check
      this.currentUser = user;
      localStorage.setItem('currentUser', JSON.stringify(user));
      return { success: true, user };
    }
    return { success: false, message: 'Invalid credentials' };
  },
  
  logout() {
    this.currentUser = null;
    localStorage.removeItem('currentUser');
  },
  
  getCurrentUser() {
    if (!this.currentUser) {
      const saved = localStorage.getItem('currentUser');
      if (saved) {
        this.currentUser = JSON.parse(saved);
      }
    }
    return this.currentUser;
  },
  
  isAuthenticated() {
    return this.getCurrentUser() !== null;
  },

  // User Management Functions
  getAllUsers() {
    return this.users;
  },

  getUserById(id) {
    return this.users.find(user => user.id === parseInt(id));
  },

  addUser(userData) {
    // Check if username or email already exists
    const existingUser = this.users.find(u => 
      u.username === userData.username || u.email === userData.email
    );
    
    if (existingUser) {
      return { 
        success: false, 
        message: 'Username or email already exists' 
      };
    }

    const newUser = {
      ...userData,
      id: this.nextUserId++,
      createdAt: new Date().toISOString(),
      modifiedAt: new Date().toISOString()
    };

    this.users.push(newUser);
    this.saveUsers();
    return { success: true, user: newUser };
  },

  updateUser(userId, userData) {
    const userIndex = this.users.findIndex(user => user.id === parseInt(userId));
    
    if (userIndex === -1) {
      return { success: false, message: 'User not found' };
    }

    // Check if username or email is taken by another user
    const existingUser = this.users.find(u => 
      u.id !== parseInt(userId) && 
      (u.username === userData.username || u.email === userData.email)
    );
    
    if (existingUser) {
      return { 
        success: false, 
        message: 'Username or email already exists' 
      };
    }

    this.users[userIndex] = {
      ...this.users[userIndex],
      ...userData,
      id: parseInt(userId), // Ensure ID doesn't change
      modifiedAt: new Date().toISOString()
    };

    this.saveUsers();
    return { success: true, user: this.users[userIndex] };
  },

  deleteUser(userId) {
    const userIndex = this.users.findIndex(user => user.id === parseInt(userId));
    
    if (userIndex === -1) {
      return { success: false, message: 'User not found' };
    }

    // Don't allow deleting the last admin
    const user = this.users[userIndex];
    if (user.role === 'Admin') {
      const adminCount = this.users.filter(u => u.role === 'Admin' && u.status === 'Active').length;
      if (adminCount <= 1) {
        return { 
          success: false, 
          message: 'Cannot delete the last active admin user' 
        };
      }
    }

    this.users.splice(userIndex, 1);
    this.saveUsers();
    return { success: true };
  },

  resetPassword(userId, newPassword) {
    const userIndex = this.users.findIndex(user => user.id === parseInt(userId));
    
    if (userIndex === -1) {
      return { success: false, message: 'User not found' };
    }

    this.users[userIndex] = {
      ...this.users[userIndex],
      modifiedAt: new Date().toISOString()
    };

    this.saveUsers();
    return { success: true };
  },

  toggleUserStatus(userId) {
    const userIndex = this.users.findIndex(user => user.id === parseInt(userId));
    
    if (userIndex === -1) {
      return { success: false, message: 'User not found' };
    }

    const user = this.users[userIndex];
    const newStatus = user.status === 'Active' ? 'Inactive' : 'Active';

    // Don't allow deactivating the last admin
    if (user.role === 'Admin' && newStatus === 'Inactive') {
      const activeAdminCount = this.users.filter(u => 
        u.role === 'Admin' && u.status === 'Active' && u.id !== parseInt(userId)
      ).length;
      
      if (activeAdminCount < 1) {
        return { 
          success: false, 
          message: 'Cannot deactivate the last active admin user' 
        };
      }
    }

    this.users[userIndex] = {
      ...user,
      status: newStatus,
      modifiedAt: new Date().toISOString()
    };

    this.saveUsers();
    return { success: true, user: this.users[userIndex] };
  },

  saveUsers() {
    localStorage.setItem('users', JSON.stringify(this.users));
  },

  loadUsers() {
    const saved = localStorage.getItem('users');
    if (saved) {
      this.users = JSON.parse(saved);
      // Update nextUserId to be higher than any existing ID
      const maxId = Math.max(...this.users.map(u => u.id), 0);
      this.nextUserId = maxId + 1;
    }
  },

  // Initialize users from localStorage or use defaults
  init() {
    this.loadUsers();
    if (this.users.length === 0) {
      this.users = [...mockUsers];
      this.saveUsers();
    }
  }
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatQuantity = (quantity, unit) => {
  return `${quantity.toLocaleString()} ${unit}`;
};

export const formatWeight = (weight) => {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2
  }).format(weight) + ' Kgs';
};

// Brand Specifications Mock Data
export const mockBrandSpecs = [
  {
    id: 1,
    brandId: 'BID-001',
    brandName: 'AgriGold Premium',
    brandCode: 'AG-001',
    buyerCompany: 'ABC Industries',
    contactPerson: 'Mr. Rajesh Kumar',
    clientPhone: '+91 9876543210',
    clientEmail: 'rajesh@abcindustries.com',
    clientAddress: '123 Industrial Area, Mumbai, Maharashtra',
    // Bag specifications
    bagSizeWidth: 22,
    bagSizeLength: 36,
    cuttingSizeWidth: 23,
    cuttingSizeLength: 37,
    bagWeight: 180,
    capacity: '50 Kg',
    top: 'Top Hemming',
    bottom: 'Single fold double stitch',
    // Material specifications
    fabricVariant: 'White',
    fabricColor: 'White',
    fabricGrams: 85,
    printingMaterial: 'BOPP',
    boppMicron: '25',
    boppFilmSize: '520',
    metallic: 'Yes',
    metallicMicrons: '12',
    metallicFilmSize: '430',
    window: 'No',
    windowMetallicFilmSize: '',
    lamination: 'Standard',
    gusset: 'No',
    handle: 'No',
    perforation: 'No',
    // Cylinder details
    printingAreaWidth: 500,
    printingAreaCircum: 350,
    cylinderSizeWidth: 520,
    cylinderSizeCircum: 370,
    numberOfCylinders: 6,
    whiteCylinder: 'Registered White',
    commonCylinder: 'Standard printing setup for AgriGold Premium bags',
    // Artwork
    artworkImageUrl: '',
    artworkFileName: '',
    artworkFileType: '',
    // Status and metadata
    userNotes: [],
    status: 'Active',
    createdDate: '2024-01-15T10:30:00.000Z',
    lastModified: '2024-01-20T10:30:00.000Z',
    createdBy: 'System Administrator'
  },
  {
    id: 2,
    brandId: 'BID-002',
    brandName: 'FreshHarvest',
    brandCode: 'FH-002',
    buyerCompany: 'XYZ Corp',
    contactPerson: 'Ms. Priya Sharma',
    clientPhone: '+91 9876543211',
    clientEmail: 'priya@xyzcorp.com',
    clientAddress: '456 Business District, Delhi, NCR',
    // Bag specifications
    bagSizeWidth: 18,
    bagSizeLength: 30,
    cuttingSizeWidth: 19,
    cuttingSizeLength: 31,
    bagWeight: 150,
    capacity: '25 Kg',
    top: 'Top Hemming with Handle',
    bottom: 'Double fold double stitch',
    // Material specifications
    fabricVariant: 'Colored',
    fabricColor: 'Green',
    fabricGrams: 75,
    printingMaterial: 'BOPP',
    boppMicron: '20',
    boppFilmSize: '430',
    metallic: 'No',
    metallicMicrons: '',
    metallicFilmSize: '',
    window: 'Yes',
    windowMetallicFilmSize: '380',
    lamination: 'Matte',
    gusset: 'Yes',
    handle: 'Yes',
    perforation: 'No',
    // Cylinder details
    printingAreaWidth: 400,
    printingAreaCircum: 300,
    cylinderSizeWidth: 430,
    cylinderSizeCircum: 320,
    numberOfCylinders: 4,
    whiteCylinder: 'Full Coat White',
    commonCylinder: 'Multi-color printing setup for FreshHarvest',
    // Artwork
    artworkImageUrl: '',
    artworkFileName: '',
    artworkFileType: '',
    // Status and metadata
    userNotes: [],
    status: 'Active',
    createdDate: '2024-01-16T10:30:00.000Z',
    lastModified: '2024-01-21T10:30:00.000Z',
    createdBy: 'System Administrator'
  },
  {
    id: 3,
    brandId: 'BID-003',
    brandName: 'ADH Brand',
    brandCode: 'ADH-003',
    buyerCompany: 'ADH Industries',
    contactPerson: 'Mr. Amit Sharma',
    clientPhone: '+91 9876543212',
    clientEmail: 'amit@adhindustries.com',
    clientAddress: '789 Industrial Park, Chennai, Tamil Nadu',
    // Bag specifications
    bagSizeWidth: 20,
    bagSizeLength: 32,
    cuttingSizeWidth: 21,
    cuttingSizeLength: 33,
    bagWeight: 160,
    capacity: '40 Kg',
    top: 'Top Hemming with Handle',
    bottom: 'Double fold single stitch',
    // Material specifications
    fabricVariant: 'Colored',
    fabricColor: 'Blue',
    fabricGrams: 80,
    printingMaterial: 'BOPP + PE',
    boppMicron: '22',
    boppFilmSize: '480',
    metallic: 'No',
    metallicMicrons: '',
    metallicFilmSize: '',
    window: 'No',
    windowMetallicFilmSize: '',
    lamination: 'Gloss',
    gusset: 'Yes',
    handle: 'Yes',
    perforation: 'Yes',
    // Cylinder details
    printingAreaWidth: 450,
    printingAreaCircum: 320,
    cylinderSizeWidth: 480,
    cylinderSizeCircum: 340,
    numberOfCylinders: 4,
    whiteCylinder: 'Full Coat White',
    commonCylinder: 'Standard 4-color printing setup for ADH Brand',
    // Artwork
    artworkImageUrl: '',
    artworkFileName: '',
    artworkFileType: '',
    // Status and metadata
    userNotes: [],
    status: 'Active',
    createdDate: '2024-01-17T10:30:00.000Z',
    lastModified: '2024-01-22T10:30:00.000Z',
    createdBy: 'System Administrator'
  }
];

// Brand Specifications Manager
export const brandSpecsManager = {
  brands: [...mockBrandSpecs],
  nextId: 4,
  nextBrandId: 4,
  
  getAllBrands() {
    return this.brands.map(brand => ({
      ...brand,
      // Ensure backward compatibility by mapping old field names to new ones
      fabricGrams: brand.fabricGrams || brand.fabricGSM,
      bagSizeWidth: brand.bagSizeWidth || brand.bagWidth,
      bagSizeLength: brand.bagSizeLength || brand.bagLength,
    }));
  },
  
  getBrandById(id) {
    const brand = this.brands.find(brand => brand.id === parseInt(id));
    if (brand) {
      // Ensure backward compatibility by mapping old field names to new ones
      return {
        ...brand,
        // Map old field names to new ones if they exist
        fabricGrams: brand.fabricGrams || brand.fabricGSM,
        bagSizeWidth: brand.bagSizeWidth || brand.bagWidth,
        bagSizeLength: brand.bagSizeLength || brand.bagLength,
      };
    }
    return null;
  },

  getBrandByName(brandName) {
    const brand = this.brands.find(brand => brand.brandName === brandName);
    if (brand) {
      // Ensure backward compatibility by mapping old field names to new ones
      return {
        ...brand,
        // Map old field names to new ones if they exist
        fabricGrams: brand.fabricGrams || brand.fabricGSM,
        bagSizeWidth: brand.bagSizeWidth || brand.bagWidth,
        bagSizeLength: brand.bagSizeLength || brand.bagLength,
      };
    }
    return null;
  },

  getBrandByBrandId(brandId) {
    const brand = this.brands.find(brand => brand.brandId === brandId);
    if (brand) {
      // Ensure backward compatibility by mapping old field names to new ones
      return {
        ...brand,
        // Map old field names to new ones if they exist
        fabricGrams: brand.fabricGrams || brand.fabricGSM,
        bagSizeWidth: brand.bagSizeWidth || brand.bagWidth,
        bagSizeLength: brand.bagSizeLength || brand.bagLength,
      };
    }
    return null;
  },
  
  getBrandsByCompany(company) {
    return this.brands.filter(brand => brand.buyerCompany === company);
  },
  
  addBrand(brandData) {
    const newBrand = {
      id: this.nextId++,
      brandId: `BID-${String(this.nextBrandId++).padStart(3, '0')}`,
      ...brandData,
      createdDate: new Date().toISOString().split('T')[0],
      lastModified: new Date().toISOString().split('T')[0],
      createdBy: 'Current User'
    };
    this.brands.unshift(newBrand);
    this.saveToStorage();
    return newBrand;
  },
  
  updateBrand(id, brandData) {
    const index = this.brands.findIndex(brand => brand.id === parseInt(id));
    if (index !== -1) {
      this.brands[index] = { 
        ...this.brands[index], 
        ...brandData,
        lastModified: new Date().toISOString().split('T')[0]
      };
      this.saveToStorage();
      return this.brands[index];
    }
    return null;
  },
  
  deleteBrand(id) {
    const index = this.brands.findIndex(brand => brand.id === parseInt(id));
    if (index !== -1) {
      this.brands.splice(index, 1);
      this.saveToStorage();
      return true;
    }
    return false;
  },
  
  searchBrands(query) {
    const searchTerm = query.toLowerCase();
    return this.brands.filter(brand => 
      brand.brandName.toLowerCase().includes(searchTerm) ||
      brand.buyerCompany.toLowerCase().includes(searchTerm) ||
      (brand.fabricVariant && brand.fabricVariant.toLowerCase().includes(searchTerm)) ||
      (brand.fabricColor && brand.fabricColor.toLowerCase().includes(searchTerm)) ||
      (brand.printingMaterial && brand.printingMaterial.toLowerCase().includes(searchTerm))
    );
  },
  
  getActiveBrands() {
    return this.brands.filter(brand => brand.status === 'Active');
  },
  
  getBrandOptions() {
    return this.getActiveBrands().map(brand => ({
      value: brand.id,
      label: `${brand.brandName} (${brand.buyerCompany})`,
      brandData: brand
    }));
  },
  
  saveToStorage() {
    localStorage.setItem('brandSpecs', JSON.stringify(this.brands));
  },
  
  // Clear all brand data for testing
  clearAllData() {
    localStorage.removeItem('brandSpecs');
    console.log('All brand specifications data cleared for fresh testing');
    // Reinitialize with empty data
    this.brands = [];
    this.nextId = 1;
    this.nextBrandId = 1;
    this.saveToStorage();
  },

  loadFromStorage() {
    const saved = localStorage.getItem('brandSpecs');
    if (saved) {
      const parsedBrands = JSON.parse(saved);
      // Check if saved brands have brandId field (new format)
      const hasBrandIds = parsedBrands.some(b => b.brandId);
      
      if (hasBrandIds) {
        // Use saved data if it has brandId fields
        this.brands = parsedBrands;
        this.nextId = Math.max(...this.brands.map(b => b.id), 0) + 1;
        // Initialize nextBrandId based on existing brandIds
        const existingBrandIds = this.brands
          .map(b => b.brandId)
          .filter(bid => bid && bid.startsWith('BID-'))
          .map(bid => parseInt(bid.replace('BID-', '')))
          .filter(num => !isNaN(num));
        this.nextBrandId = existingBrandIds.length > 0 ? Math.max(...existingBrandIds) + 1 : 1;
      } else {
        // Clear corrupted data and reinitialize with mockBrandSpecs
        localStorage.removeItem('brandSpecs');
        this.brands = [...mockBrandSpecs];
        this.nextId = Math.max(...this.brands.map(b => b.id), 0) + 1;
        this.nextBrandId = 3; // Since we have BID-001 and BID-002
        this.saveToStorage();
      }
    } else {
      // If no saved data, initialize with mockBrandSpecs and save to localStorage
      this.brands = [...mockBrandSpecs];
      if (this.brands.length > 0) {
        this.nextId = Math.max(...this.brands.map(b => b.id), 0) + 1;
        // Initialize nextBrandId for mockBrandSpecs
        this.nextBrandId = 4; // Since we have BID-001, BID-002, and BID-003
        this.saveToStorage();
      }
    }
  },
  
  getStats() {
    const totalBrands = this.brands.length;
    const activeBrands = this.brands.filter(b => b.status === 'Active').length;
    const uniqueCompanies = [...new Set(this.brands.map(b => b.buyerCompany))].length;
    const materialTypes = [...new Set(this.brands.map(b => b.materialType))].length;
    
    return {
      totalBrands,
      activeBrands,
      uniqueCompanies,
      materialTypes
    };
  },

  async downloadAllBrandsPDF() {
    try {
      // Dynamic import to avoid bundling issues
      const jsPDF = (await import('jspdf')).jsPDF;
      const brands = this.getAllBrands();
      
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageHeight = 297; // A4 height in mm
      const margin = 20;
      let yPosition = margin;
      
      // Title
      pdf.setFontSize(20);
      pdf.text('Brand Specifications Report', margin, yPosition);
      yPosition += 15;
      
      // Date
      pdf.setFontSize(12);
      pdf.text(`Generated: ${new Date().toLocaleDateString()}`, margin, yPosition);
      yPosition += 10;
      
      // Summary
      pdf.text(`Total Brands: ${brands.length}`, margin, yPosition);
      yPosition += 20;
      
      // Brand details
      brands.forEach((brand, index) => {
        // Check if we need a new page
        if (yPosition > pageHeight - 60) {
          pdf.addPage();
          yPosition = margin;
        }
        
        pdf.setFontSize(16);
        pdf.text(`${index + 1}. ${brand.brandName} (${brand.brandCode})`, margin, yPosition);
        yPosition += 10;
        
        pdf.setFontSize(11);
        const details = [
          `Company: ${brand.buyerCompany}`,
          `Material: ${brand.materialType || 'N/A'}`,
          `Bag Size: ${brand.bagLength}"L x ${brand.bagWidth}"W`,
          `Weight: ${brand.bagWeight || 'N/A'} gms`,
          `GSM: ${brand.fabricGSM || 'N/A'}`,
          `Status: ${brand.status}`,
          `Created: ${new Date(brand.createdDate).toLocaleDateString()}`
        ];
        
        details.forEach(detail => {
          pdf.text(detail, margin + 5, yPosition);
          yPosition += 5;
        });
        
        yPosition += 10;
      });
      
      pdf.save(`brand-specifications-${new Date().toISOString().split('T')[0]}.pdf`);
      return { success: true, message: 'Brand specifications PDF downloaded successfully' };
    } catch (error) {
      console.error('PDF generation error:', error);
      return { success: false, message: 'Failed to generate PDF' };
    }
  },

  downloadAllBrands() {
    const brands = this.getAllBrands();
    const dataStr = JSON.stringify(brands, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `brand-specifications-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return { success: true, message: 'Brand specifications downloaded successfully' };
  },

  importBrands(brandsData) {
    try {
      if (Array.isArray(brandsData)) {
        this.brands = [...brandsData];
        if (this.brands.length > 0) {
          this.nextId = Math.max(...this.brands.map(b => b.id), 0) + 1;
        }
        this.saveToStorage();
        return { success: true, message: `${brandsData.length} brand specifications imported successfully` };
      } else {
        return { success: false, message: 'Invalid data format' };
      }
    } catch (error) {
      return { success: false, message: 'Failed to import data: ' + error.message };
    }
  },

  async downloadBrandPDF(brandId) {
    try {
      const jsPDF = (await import('jspdf')).jsPDF;
      const brand = this.getBrandById(brandId);
      
      if (!brand) {
        return { success: false, message: 'Brand not found' };
      }
      
      const pdf = new jsPDF('p', 'mm', 'a4');
      const margin = 20;
      let yPosition = margin;
      
      // Header
      pdf.setFontSize(20);
      pdf.text(`${brand.brandName} Specification`, margin, yPosition);
      yPosition += 15;
      
      pdf.setFontSize(12);
      pdf.text(`Brand Code: ${brand.brandCode}`, margin, yPosition);
      yPosition += 7;
      pdf.text(`Generated: ${new Date().toLocaleDateString()}`, margin, yPosition);
      yPosition += 15;
      
      // Client Details
      pdf.setFontSize(14);
      pdf.text('Client Details', margin, yPosition);
      yPosition += 8;
      
      pdf.setFontSize(11);
      const clientDetails = [
        `Company: ${brand.buyerCompany}`,
        `Contact Person: ${brand.contactPerson || 'N/A'}`,
        `Phone: ${brand.clientPhone || 'N/A'}`,
        `Email: ${brand.clientEmail || 'N/A'}`
      ];
      
      clientDetails.forEach(detail => {
        pdf.text(detail, margin + 5, yPosition);
        yPosition += 6;
      });
      yPosition += 10;
      
      // Bag Specifications
      pdf.setFontSize(14);
      pdf.text('Bag Specifications', margin, yPosition);
      yPosition += 8;
      
      pdf.setFontSize(11);
      const bagSpecs = [
        `Bag Size: ${brand.bagSizeWidth || 'N/A'}" W x ${brand.bagSizeLength || 'N/A'}" L`,
        `Cutting Size: ${brand.cuttingSizeWidth || 'N/A'}" W x ${brand.cuttingSizeLength || 'N/A'}" L`,
        `Weight: ${brand.bagWeight || 'N/A'} gms`,
        `Capacity: ${brand.capacity || 'N/A'}`,
        `Top: ${brand.top || 'N/A'}`,
        `Bottom: ${brand.bottom || 'N/A'}`,
        `Handle: ${brand.handle === 'Yes' ? 'Yes' : 'No'}`,
        `Gusset: ${brand.gusset === 'Yes' ? 'Yes' : 'No'}`,
        `Perforation: ${brand.perforation === 'Yes' ? 'Yes' : 'No'}`
      ];
      
      bagSpecs.forEach(spec => {
        pdf.text(spec, margin + 5, yPosition);
        yPosition += 6;
      });
      yPosition += 10;
      
      // Material Specifications
      pdf.setFontSize(14);
      pdf.text('Material Specifications', margin, yPosition);
      yPosition += 8;
      
      pdf.setFontSize(11);
      const materialSpecs = [
        `Fabric Variant: ${brand.fabricVariant || 'N/A'}`,
        `Fabric Color: ${brand.fabricColor || 'N/A'}`,
        `Fabric Grams (GSM): ${brand.fabricGrams || 'N/A'}`,
        `Printing Material: ${brand.printingMaterial || 'N/A'}`,
        `BOPP Micron: ${brand.boppMicron || 'N/A'}`,
        `BOPP Film Size: ${brand.boppFilmSize ? brand.boppFilmSize + 'mm' : 'N/A'}`,
        `Metallic: ${brand.metallic || 'No'}`,
        `Metallic Microns: ${brand.metallicMicrons || 'N/A'}`,
        `Metallic Film Size: ${brand.metallicFilmSize ? brand.metallicFilmSize + 'mm' : 'N/A'}`,
        `Window: ${brand.window || 'No'}`,
        `Window Film Size: ${brand.windowMetallicFilmSize ? brand.windowMetallicFilmSize + 'mm' : 'N/A'}`,
        `Lamination: ${brand.lamination || 'N/A'}`
      ];
      
      materialSpecs.forEach(spec => {
        pdf.text(spec, margin + 5, yPosition);
        yPosition += 6;
      });
      yPosition += 10;
      
      
      // Cylinder Details
      if (brand.printingAreaWidth) {
        pdf.setFontSize(14);
        pdf.text('Cylinder Details', margin, yPosition);
        yPosition += 8;
        
        pdf.setFontSize(11);
        const cylinderDetails = [
          `Printing Area: ${brand.printingAreaWidth}mm x ${brand.printingAreaCircum}mm`,
          `Cylinder Size: ${brand.cylinderSizeWidth}mm x ${brand.cylinderSizeCircum}mm`,
          `Number of Cylinders: ${brand.numberOfCylinders || 'N/A'}`,
          `White Cylinder: ${brand.whiteCylinder || 'N/A'}`
        ];
        
        cylinderDetails.forEach(detail => {
          pdf.text(detail, margin + 5, yPosition);
          yPosition += 6;
        });
        yPosition += 10;
      }
      
      // Status and Dates
      pdf.setFontSize(14);
      pdf.text('Status & Information', margin, yPosition);
      yPosition += 8;
      
      pdf.setFontSize(11);
      const statusInfo = [
        `Status: ${brand.status}`,
        `Created Date: ${new Date(brand.createdDate).toLocaleDateString()}`,
        `Last Modified: ${brand.lastModified}`,
        `Created By: ${brand.createdBy}`
      ];
      
      statusInfo.forEach(info => {
        pdf.text(info, margin + 5, yPosition);
        yPosition += 6;
      });
      
      pdf.save(`${brand.brandName}-${brand.brandCode}-specs.pdf`);
      return { success: true, message: 'Brand specification PDF downloaded successfully' };
    } catch (error) {
      console.error('PDF generation error:', error);
      return { success: false, message: 'Failed to generate PDF' };
    }
  },

  downloadBrandById(brandId) {
    const brand = this.getBrandById(brandId);
    if (!brand) {
      return { success: false, message: 'Brand not found' };
    }
    
    const dataStr = JSON.stringify(brand, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${brand.brandName}-${brand.brandCode}-specs.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return { success: true, message: 'Brand specification downloaded successfully' };
  },

  updateBrand(brandId, updatedData) {
    const brandIndex = this.brands.findIndex(brand => brand.id === brandId);
    if (brandIndex === -1) {
      return { success: false, message: 'Brand not found' };
    }
    
    this.brands[brandIndex] = { ...this.brands[brandIndex], ...updatedData };
    this.saveToStorage();
    
    return { success: true, message: 'Brand updated successfully', brand: this.brands[brandIndex] };
  },

  deleteBrand(brandId) {
    const brandIndex = this.brands.findIndex(brand => brand.id === brandId);
    if (brandIndex === -1) {
      return { success: false, message: 'Brand not found' };
    }
    
    const deletedBrand = this.brands[brandIndex];
    this.brands.splice(brandIndex, 1);
    this.saveToStorage();
    
    return { success: true, message: `${deletedBrand.brandName} deleted successfully` };
  },

  getBrandById(brandId) {
    return this.brands.find(brand => brand.id === brandId) || null;
  },

  getBrandNames() {
    return this.brands
      .filter(brand => brand.status === 'Active')
      .map(brand => ({
        id: brand.id,
        value: brand.brandName,
        label: brand.brandName,
        code: brand.brandCode,
        company: brand.buyerCompany
      }));
  }
};

// Initialize brand specs from storage
brandSpecsManager.loadFromStorage();

// Brand Specs Notifications Manager
export const orderNotificationsManager = {
  notifications: [],
  nextId: 1000,
  
  init() {
    const saved = localStorage.getItem('orderNotifications');
    if (saved) {
      this.notifications = JSON.parse(saved);
      // Update nextId to be higher than any existing ID
      const maxId = Math.max(...this.notifications.map(n => n.id), this.nextId);
      this.nextId = maxId + 1;
    }
  },
  
  saveNotifications() {
    localStorage.setItem('orderNotifications', JSON.stringify(this.notifications));
  },
  
  addOrderNoteNotification(orderId, orderBrandName, notesCount, userName, noteText) {
    const notification = {
      id: this.nextId++,
      type: 'info',
      title: 'New Order Note',
      message: `${userName} added a note to order "${orderBrandName}"`,
      noteText: noteText.substring(0, 50) + (noteText.length > 50 ? '...' : ''),
      orderId: orderId,
      orderBrandName: orderBrandName,
      userName: userName,
      category: 'order_notes',
      timestamp: new Date().toISOString(),
      read: false
    };
    
    this.notifications.unshift(notification); // Add to beginning
    this.saveNotifications();
    return notification;
  },
  
  getNotifications() {
    return this.notifications.slice(0, 10); // Show only latest 10 notifications
  },
  
  getUnreadCount() {
    return this.notifications.filter(n => !n.read).length;
  },
  
  markAsRead(id) {
    const notification = this.notifications.find(n => n.id === id);
    if (notification) {
      notification.read = true;
      this.saveNotifications();
    }
  },
  
  clearNotification(id) {
    this.notifications = this.notifications.filter(n => n.id !== id);
    this.saveNotifications();
    return this.notifications;
  },
  
  clearAllNotifications() {
    this.notifications = [];
    this.saveNotifications();
  }
};

export const brandSpecsNotificationsManager = {
  notifications: [],
  
  generateNotifications() {
    const brands = brandSpecsManager.getAllBrands();
    this.notifications = [];
    
    // Check for inactive brands
    const inactiveBrands = brands.filter(b => b.status === 'Inactive');
    if (inactiveBrands.length > 0) {
      this.notifications.push({
        id: 1,
        type: 'warning',
        title: 'Inactive Brand Specifications',
        message: `${inactiveBrands.length} brand specification(s) are currently inactive`,
        count: inactiveBrands.length,
        category: 'brand_status',
        timestamp: new Date().toISOString()
      });
    }
    
    // Check for recently added brands (within last 7 days)
    const recentBrands = brands.filter(b => {
      const createdDate = new Date(b.createdDate);
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      return createdDate >= weekAgo;
    });
    
    if (recentBrands.length > 0) {
      this.notifications.push({
        id: 2,
        type: 'info',
        title: 'New Brand Specifications',
        message: `${recentBrands.length} new brand specification(s) added recently`,
        count: recentBrands.length,
        category: 'new_brands',
        timestamp: new Date().toISOString()
      });
    }
    
    // Check for brands missing key specifications
    const incompleteBrands = brands.filter(b => 
      !b.bagWeight || !b.fabricGrams
    );
    
    if (incompleteBrands.length > 0) {
      this.notifications.push({
        id: 3,
        type: 'error',
        title: 'Incomplete Specifications',
        message: `${incompleteBrands.length} brand specification(s) have missing required data`,
        count: incompleteBrands.length,
        category: 'incomplete_specs',
        timestamp: new Date().toISOString()
      });
    }
    
    return this.notifications;
  },
  
  getNotifications() {
    return this.generateNotifications();
  },
  
  getNotificationCount() {
    return this.getNotifications().length;
  },
  
  clearNotification(id) {
    this.notifications = this.notifications.filter(n => n.id !== id);
    return this.notifications;
  }
};